/**
 * Trading Volume API (GET /api/trading-volume/history)
 */

import { API_CONFIG } from '@/config/api';
import { apiFetch } from '@/lib/apiFetch';

const BASE = API_CONFIG.TRADING_VOLUME_PATH_PREFIX;

export interface TradingVolumeRecord {
  ts: string;
  exchange: string;
  market_type: string;
  symbol: string;
  inst_id: string;
  volume_base_24h: number;
  volume_quote_24h: number;
}

export interface TradingVolumeResponse {
  success: boolean;
  count: number;
  data: TradingVolumeRecord[];
}

export interface TradingVolumeParams {
  exchange?: string;
  market_type?: 'spot' | 'future';
  symbol?: string;
  inst_id?: string;
  start_time?: string;
  end_time?: string;
  limit?: number;
}

export async function getTradingVolume(params: TradingVolumeParams): Promise<TradingVolumeResponse> {
  const q = new URLSearchParams();
  if (params.exchange) q.set('exchange', params.exchange);
  if (params.market_type) q.set('market_type', params.market_type);
  if (params.symbol) q.set('symbol', params.symbol);
  if (params.inst_id) q.set('inst_id', params.inst_id);
  if (params.start_time != null) q.set('start_time', params.start_time);
  if (params.end_time != null) q.set('end_time', params.end_time);
  if (params.limit != null) q.set('limit', String(params.limit));

  const res = await apiFetch(`${BASE}/history?${q.toString()}`, { method: 'GET' });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `HTTP ${res.status}`);
  }
  return res.json() as Promise<TradingVolumeResponse>;
}
